import axios, { AxiosResponse } from 'axios';
import { useState } from 'react';
import { EMBED_API_ROUTES } from './constants';

// TODO: get constant from shared services
const SSO_EMBED_ENDPOINT = '/sso-embed';
const API_URL = window.__env__.PREDICT_API_URL + SSO_EMBED_ENDPOINT;

interface TokenData {
  access_token: string;
  token_type: string;
  id_token: string;
  expires_in: number;
}

function useSsoEmbedTokenApi() {
  const [data, setData] = useState<TokenData>({ access_token: '', id_token: '', token_type: '', expires_in: 0 });
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  async function fetchData(code: string): Promise<TokenData | undefined> {
    try {
      const response: AxiosResponse = await axios.post(`${API_URL}${EMBED_API_ROUTES.ACCESS_RECORD}?code=${code}`);
      return response.data;
    } catch (error) {
      // console.error(error);
    }
  }

  const fetchToken = (code: string) => {
    setIsLoading(true);

    fetchData(code)
      .then(data => {
        if (data) {
          setData(data);
        }
      })
      .catch(error => {
        setError(error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return { data, error, isLoading, fetchToken };
}

export default useSsoEmbedTokenApi;

/**
 * fetchTokenAPI
 *
 * API call on the SSO Embed Agent to return access tokens.
 *
 * @param code - code provided for the code flow auth flow.
 * @returns Promise - resolves to return access token.
 */
export async function fetchTokenApi(code: string): Promise<TokenData | undefined> {
  try {
    const response: AxiosResponse = await axios.post(`${API_URL}${EMBED_API_ROUTES.ACCESS_RECORD}?code=${code}`);
    return response.data;
  } catch (error) {
    // console.error(error);
  }
}

/**
 * fetchDataSyncApi
 *
 * API call on the SSO Embed Agent to initiate a data sync.
 *
 * @param state - state provided by the 3rd party.
 * @returns Promise - resolves to return sync status.
 */
export async function fetchDataSyncApi(state: string): Promise<unknown> {
  try {
    const response: AxiosResponse = await axios.post(`${API_URL}${EMBED_API_ROUTES.DATA_SYNC_REQUEST}?state=${state}`);
    return response.data;
  } catch (error) {
    // console.error(error);
  }
}
